import Minus from "./Minus";
export default Minus